module.exports = __webpack_public_path__ + "static/media/twittericon.3d74e8bf.png";